// Route definitions
export const ROUTES = {
  LANDING: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  PASSWORD_RESET: '/password-reset',
  DASHBOARD: '/dashboard',
  MENU_BUILDER: '/menu',
  OPERATING_HOURS: '/hours',
  DELIVERY_ZONES: '/zones',
  CALL_HISTORY: '/calls',
  SETTINGS: '/settings',
} as const;

